import { Header, Icon, Segment } from 'semantic-ui-react';

export default function NotFound() {
    return (
        <Segment placeholder>
            <Header icon>
                <Icon name='search' />
                    Resident cannot be identified.  Please only use the link provided to you.
            </Header>
            
        </Segment>
    )
}